import * as React from 'react';

import { Toggle } from '../../../components';
import { GROUP_SHIPMENT_TOOLTIP_TEXT } from '../../../constants/shipping';

import styles from '../ShippingDetailsContainer.module.scss';

interface IProps {
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const GroupShipmentToggle: React.FC<IProps> = ({ checked, onChange, disabled }) => (
  <Toggle
    className={styles.toggle}
    sliderClassName={styles.toggleSlider}
    onChange={onChange}
    value={checked}
    checked={checked}
    defaultValue={false}
    disabled={disabled}
    dataAction="toggle_office_dropship"
    hint={GROUP_SHIPMENT_TOOLTIP_TEXT}
  >
    Group Shipment
  </Toggle>
);

export default GroupShipmentToggle;
